import { isTreeStructurePath, isTreeStructureTerminator } from "./defaultMenuStructure";
const debug = process.env.REACT_APP_DEBUG && false;
/** takes a `DomainMap` and inserts `TreeDefinition`'s into prescribed `Domain`'s */
export const addExternalDomainTreesToTreeDefinitionMap = ({ externalDomainMapping, treeDefinitionMap }) => {
    const { domainKey, sortOrder, targetSectionPath, treeDefMap } = externalDomainMapping;
    const [thisTargetSection, ...nextTargetSectionPath] = targetSectionPath;
    if (!treeDefinitionMap[thisTargetSection]) {
        treeDefinitionMap[thisTargetSection] = {};
    }
    const targetDef = treeDefinitionMap[thisTargetSection];
    const nextTargetSection = nextTargetSectionPath.at(0);
    if (nextTargetSection) {
        if (isTreeStructurePath(targetDef)) {
            if (targetDef.next[nextTargetSection]) {
                addExternalDomainTreesToTreeDefinitionMap({
                    externalDomainMapping: { ...externalDomainMapping, targetSectionPath: nextTargetSectionPath },
                    treeDefinitionMap: targetDef.next,
                });
            }
            else {
                debug &&
                    console.log(`Config attempted to add a tree definition to a non-existent path: ${thisTargetSection} > ${nextTargetSection}`, JSON.stringify(targetDef));
                throw new Error(`Config attempted to add a tree definition to a non-existent path: ${thisTargetSection} > ${nextTargetSection}`);
            }
        }
        else {
            throw new Error(`Config attempted to add tree definition to a terminated path: ${thisTargetSection} > ${nextTargetSection}`);
        }
    }
    else {
        if (!isTreeStructureTerminator(targetDef)) {
            if (!targetDef.next) {
                targetDef.next = {};
            }
            if (isTreeStructurePath(targetDef)) {
                const entries = Object.entries(targetDef.next);
                const targetIdx = entries.findIndex(([k, v,], i) => typeof v.sortOrder === 'number' && v.sortOrder > (sortOrder ?? i));
                const resolvedTargetIdx = targetIdx === -1 ? entries.length : targetIdx;
                debug && console.log(`addExternalDomainTreesToTreeDefinitionMap ordering ${domainKey} with sortOrder ${sortOrder} at ${resolvedTargetIdx} (${targetIdx}) in ${entries.map((entry) => entry[1].sortOrder).join(', ')}`);
                entries.splice(resolvedTargetIdx, 0, [domainKey, { sortOrder, next: treeDefMap }]);
                targetDef.next = Object.fromEntries(entries);
            }
        }
    }
    return treeDefinitionMap;
};
